import React from 'react';
import styles from './_style.module.scss';

const SelectUnit = ({ id, drawing, unit, setUnit }) => {
  const selectUnit = (selectedUnit) => {
    setUnit(() => selectedUnit);
  };

  return (
    <div className={styles.formGroup} data-widget-element="form-group">
      <input type="hidden" name="unit" value={unit} />
      <label className={styles.label} data-widget-element="label">{t('my_drawings.options_unit_short')}</label>
      <div className={styles.unitToggle} data-widget-element="unit-toggle">
        <button
          type="button"
          className={`${styles.unitButton} ${unit === 'mm' ? styles.unitButtonActive : ''}`}
          onClick={() => selectUnit('mm')}
          data-widget-element="unit-button"
          data-active={unit === 'mm'}
        >
          {t('drawing.unit_mm')}
        </button>
        <button
          type="button"
          className={`${styles.unitButton} ${unit === 'in' ? styles.unitButtonActive : ''}`}
          onClick={() => selectUnit('in')}
          data-widget-element="unit-button"
          data-active={unit === 'in'}
        >
          {t('drawing.unit_in')}
        </button>
      </div>
    </div>
  );
};

export default SelectUnit;
